import { createSlice } from '@reduxjs/toolkit';

const entitySlice = createSlice({
    name: 'entities',
    initialState: [],
    reducers: {
        addEntity: (entities, action) => {
            const { entity } = action.payload;
            entities.push(entity);
        }
    }
});

export const { addEntity } = entitySlice.actions;

export default entitySlice.reducer;